import billingTranslations from "@src/modules/member/modules/settings/billing/_langs/en-US";
import customFieldTranslations from "@src/modules/member/modules/settings/custom-fields/_langs/en-US.ts";
import customerEmailTranslations from "@src/modules/member/modules/settings/customer-email/_langs/en-US";
import clientContactTypesTranslations from "@src/modules/member/modules/settings/customer-email/contact-types/_langs/en-US";
import senderDomainTranslations from "@src/modules/member/modules/settings/customer-email/sender-domain/_langs/en-US";
import expenseBudgetsTranslations from "@src/modules/member/modules/settings/expense-budgets/_langs/en-US";
import expenseCategoriesTranslations from "@src/modules/member/modules/settings/expense-categories/_langs/en-US";
import expensesInboundTranslations from "@src/modules/member/modules/settings/expenses-inbound/_langs/en-US";
import integrationsTranslations from "@src/modules/member/modules/settings/integrations/_langs/en-US";
import invoiceSettingsTranslations from "@src/modules/member/modules/settings/invoices/_langs/en-US.ts";
import organizationTranslations from "@src/modules/member/modules/settings/organization/_langs/en-US";
import profileTranslations from "@src/modules/member/modules/settings/profile/_langs/en-US";
import reportSubscriptionsTranslations from "@src/modules/member/modules/settings/report-subscriptions/_langs/en-US";
import servicesTranslations from "@src/modules/member/modules/settings/services/_langs/en-US";
import timeEntriesTranslations from "@src/modules/member/modules/settings/time-entries/_langs/en-US";

export default {
  customFields: customFieldTranslations,
  back: "Back",
  billing: billingTranslations,
  // Existing translation keys are kept flat under their original namespaces
  // (clientContactTypes, senderDomain) so we don't churn every consumer's
  // `t('member.settings.clientContactTypes.*')` call. The customerEmail
  // namespace only holds the new parent layout's strings.
  clientContactTypes: clientContactTypesTranslations,
  customerEmail: customerEmailTranslations,
  expenseBudgets: expenseBudgetsTranslations,
  expenseCategories: expenseCategoriesTranslations,
  expensesInbound: expensesInboundTranslations,
  invoices: invoiceSettingsTranslations,
  organization: organizationTranslations,
  profile: profileTranslations,
  reportSubscriptions: reportSubscriptionsTranslations,
  integrations: integrationsTranslations,
  senderDomain: senderDomainTranslations,
  services: servicesTranslations,
  timeEntries: timeEntriesTranslations,
};
